class MiniCart extends HeaderMenu {
  constructor() {
    super();
    this.isDisabled = this.attributes.hasOwnProperty('disabled');
    this.closeButton = this.querySelector('.mini-cart__close');
    this.addEventListener('click', this.onCloseButtonClick.bind(this));
  }

  onCloseButtonClick(event) {
    const target = event.target;
    if (target.classList.contains('mini-cart__close') || target.closest('.mini-cart__close')) {
      event.preventDefault();
      this.close();
    }
  }

  onFocusOut() {
    return;
  }

  onMouseEnter() {
    if (this.mainDetailsToggle.open || this.isDisabled) return;
    this.open();
  }

  onSummaryClick(event) {
    if (!this.mql.matches || this.isDisabled) {
      event.preventDefault();
    }
  }
}

customElements.define('mini-cart', MiniCart);

class MiniCartItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.mini-cart__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('mini-cart-items', MiniCartItems);